import api from "./api";
import { resvProps, updateResvInfProps } from "interface/mypage";

// 예약리스트
export const resvsApi = async (params: resvProps) => {
  const res = await api({
    method: "post",
    url: `roomResv/myResvList`,
    data: params,
  });

  return res;
};

//예약상세 조회
export const resvInfApi = async (rmPdNo: string) => {
  const res = await api({
    method: "get",
    url: `roomResv/myResvInfo/${rmPdNo}`,
  });

  return res;
};

//얘약 취소
export const cnlResvApi = async (rmPdNo: string) => {
  const res = await api({
    method: "get",
    url: `roomResv/cnlRmResv/${rmPdNo}`,
  });

  return res;
};

//예약 취소조회
export const cnlResvInfApi = async (rmPdNo: string) => {
  const res = await api({
    method: "get",
    url: `roomResv/cnlRmResvInfo/${rmPdNo}`,
  });

  return res;
};

//예약자정보 변경
export const updateResvInfApi = async (params: updateResvInfProps) => {
  const res = await api({
    method: "post",
    url: `roomResv/updateResvCstInfo`,
    data: params,
  });

  return res;
};

//예약확정이메일발송
export const sendResvMailApi = async (rmPdNo: string) => {
  const res = await api({
    method: "get",
    url: `roomResv/sendResvConfirmMail/${rmPdNo}`,
  });
  return res;
};

/*******************  다객실   **************/

//나의 예약리스트_다건
export const myResvListMultiApi = async (params: resvProps) => {
  const res = await api({
    method: "post",
    url: "roomResvMulti/myResvList",
    data: params,
  });

  return res;
};

//나의 예약상세_다건
export const myResvDetailMultiApi = async (rmResvNo: string) => {
  const res = await api({
    method: "get",
    url: `roomResvMulti/myResvDtl/${rmResvNo}`,
  });

  return res;
};
